import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material'
import { CircularProgress } from '@mui/material'
import { AddressPopup } from 'feature/addresses/components/AddressPopup/AddressPopup'
// eslint-disable-next-line max-len
import { ControlsType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { AddressSelectInput } from 'widget/AddressSelectInput'

import {
  OrderStepContent,
  OrderStepLayout,
} from '../CreateOrder/OrderStepLayout'
import { ProductOrderFooter } from '../CreateOrder/ProductOrderFooter'
import { ProductOrderHeader } from '../CreateOrder/ProductOrderHeader'
import { StepComponentProps } from '../types/StepComponentProps'

import styles from './OrderStepAddress.module.scss'
import { useOrderStepAddress } from './useOrderStepAddress'

// шаг 3
// выбор адреса для заявки
export function OrderStepAddress(props: StepComponentProps) {
  const {
    isButtonLoading,
    isAddressLoading,
    isPopupView,
    isValid,
    setPopupView,
    handlePreviousStep,
    openCityPopupHandler,
    handleCompleteStep,
    getDescription,
  } = useOrderStepAddress(props)

  if (isPopupView) {
    return (
      <main>
        <ProductOrderHeader step='Шаг 3' title='Адрес объекта' />
        <AddressPopup setViewMode={() => setPopupView(false)} />
      </main>
    )
  }

  return (
    <OrderStepLayout>
      <main className={styles.main}>
        <div className={styles.productOrderHeaderDescription}>
          <ProductOrderHeader
            step='Шаг 3'
            title='Адрес объекта'
            description={getDescription()}
          />
        </div>
        <OrderStepContent>
          {isAddressLoading ? (
            <div className={styles.addressLoader}>
              <CircularProgress />
            </div>
          ) : (
            <div className={styles.orderAddress}>
              <AddressSelectInput
                className={styles.input}
                onClick={openCityPopupHandler}
              />
              <YandexMap
                className={styles.map}
                isDadata
                marks={[MarkType.geolocationMark, MarkType.clickMark]}
                controls={[
                  ControlsType.GeolocationControlUnit,
                  ControlsType.ZoomControl,
                ]}
              />
            </div>
          )}
        </OrderStepContent>
      </main>
      <ProductOrderFooter
        nextButton={{
          onClick: handleCompleteStep,
          Icon: <ChevronRightRounded />,
          text: 'Далее',
          disabled: !isValid || isButtonLoading,
          isLoading: isButtonLoading,
        }}
        prevButton={{
          onClick: handlePreviousStep,
          Icon: <ChevronLeftRounded />,
          text: 'Предыдущий шаг',
        }}
      />
    </OrderStepLayout>
  )
}
